import UserActionError from '@/interfaces/errors/userAction';
const PREFIX = 'common: components: Editor: hooks: useDeleteWidget: errors';
export const ERROR_CODES = {
  unpermissioned: `${PREFIX}unpermissioned`,
  unfound: `${PREFIX}unfound`,
  unknown: `${PREFIX}unknown`
};
export const USER_MESSAGES = {
  unpermissioned: 'You do not have permission to delete this widget, please login again or contact an admin',
  unfound: 'Unable to delete that widget, it was not found by the system',
  unknown: 'Unexpected issue deleting widget, please try again or contact support'
};
export const createUnpermissionedError = (prefix, err) => {
  const userErr = new UserActionError(`${prefix} unauthorized request: ${err}`);
  userErr.userMessage = USER_MESSAGES.unpermissioned;
  userErr.code = ERROR_CODES.unpermissioned;
  userErr.stack = err.stack;
  return userErr;
};
export const createUnfoundError = (prefix, err) => {
  const userErr = new UserActionError(`${prefix} unfound widget request: ${err}`);
  userErr.userMessage = USER_MESSAGES.unknown;
  userErr.code = ERROR_CODES.unfound;
  userErr.stack = err.stack;
  return userErr;
};
export const createUnknownError = (prefix, err) => {
  const userErr = new UserActionError(`${prefix} unknown server error: ${err}`);
  userErr.userMessage = USER_MESSAGES.unknown;
  userErr.code = ERROR_CODES.unknown;
  userErr.stack = err.stack;
  return userErr;
};